var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.553 2.997a2.23 2.23 0 0 0-.7.167h-.003c-.214.085-1.23.513-2.775 1.16l-5.537 2.332-7.878 3.32.047-.018s-.27.088-.55.281a1.521 1.521 0 0 0-.44.425 1.248 1.248 0 0 0-.208.832c.067.542.419.867.67 1.046.256.182.499.267.499.267h.006l3.662 1.233c.164.527 1.116 3.656 1.344 4.377.135.43.267.7.431.905.08.106.173.194.284.264a.839.839 0 0 0 .185.079l-.038-.009c.011.003.02.012.029.015.03.009.05.012.088.017.58.176 1.046-.184 1.046-.184l.026-.02 2.162-1.97 3.624 2.78.082.036c.756.331 1.52.146 1.925-.179.407-.328.566-.747.566-.747l.026-.067 2.8-14.347c.08-.354.1-.685.013-1.008a1.355 1.355 0 0 0-.587-.785 1.404 1.404 0 0 0-.8-.202Zm-.076 1.538c-.003.047.005.041-.015.132v.009l-2.774 14.197c-.012.02-.033.064-.088.108-.059.047-.106.077-.349-.02l-4.433-3.398-2.677 2.44.562-3.592 7.242-6.75c.3-.278.2-.337.2-.337.02-.34-.452-.1-.452-.1l-9.131 5.658-.003-.015-4.377-1.473v-.003l-.012-.003a.202.202 0 0 0 .023-.01l.024-.01.023-.01 7.881-3.319 5.534-2.332A788.34 788.34 0 0 1 19.4 4.559c.062-.024.033-.024.077-.024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.0055ef5094f40acb5ce4a2b45bb122f4.svg";
export { ForwardRef as ReactComponent };